/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const accessRequestByEmail = /* GraphQL */ `
  query AccessRequestByEmail(
    $email: String!
    $filter: ModelAccessRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    accessRequestByEmail(
      email: $email
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        adminNotes
        createdAt
        description
        email
        id
        owner
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentScheduleRunnersByScheduleIdAndSortOrder = /* GraphQL */ `
  query AgentScheduleRunnersByScheduleIdAndSortOrder(
    $filter: ModelAgentScheduleRunnerFilterInput
    $limit: Int
    $nextToken: String
    $scheduleId: ID!
    $sortDirection: ModelSortDirection
    $sortOrder: ModelIntKeyConditionInput
  ) {
    agentScheduleRunnersByScheduleIdAndSortOrder(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      scheduleId: $scheduleId
      sortDirection: $sortDirection
      sortOrder: $sortOrder
    ) {
      items {
        attachments
        createdAt
        emailCondition
        emailConditionMode
        id
        organizationId
        owner
        prompt
        scheduleId
        sendEmail
        sortOrder
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentScheduleRunsByScheduleIdAndCreatedAt = /* GraphQL */ `
  query AgentScheduleRunsByScheduleIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelAgentScheduleRunFilterInput
    $limit: Int
    $nextToken: String
    $scheduleId: ID!
    $sortDirection: ModelSortDirection
  ) {
    agentScheduleRunsByScheduleIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      scheduleId: $scheduleId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        error
        id
        organizationId
        owner
        scheduleId
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const agentSchedulesByStatusAndNextRunAt = /* GraphQL */ `
  query AgentSchedulesByStatusAndNextRunAt(
    $filter: ModelAgentScheduleFilterInput
    $limit: Int
    $nextRunAt: ModelStringKeyConditionInput
    $nextToken: String
    $sortDirection: ModelSortDirection
    $status: AgentScheduleStatus!
  ) {
    agentSchedulesByStatusAndNextRunAt(
      filter: $filter
      limit: $limit
      nextRunAt: $nextRunAt
      nextToken: $nextToken
      sortDirection: $sortDirection
      status: $status
    ) {
      items {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const composedForecastAssetsByAssetIDAndComposedForecastID = /* GraphQL */ `
  query ComposedForecastAssetsByAssetIDAndComposedForecastID(
    $assetID: ID!
    $composedForecastID: ModelIDKeyConditionInput
    $filter: ModelComposedForecastAssetsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    composedForecastAssetsByAssetIDAndComposedForecastID(
      assetID: $assetID
      composedForecastID: $composedForecastID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        assetID
        composedForecastID
        createdAt
        icon
        id
        isDefault
        organizationId
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const composedForecastAssetsByComposedForecastIDAndAssetID = /* GraphQL */ `
  query ComposedForecastAssetsByComposedForecastIDAndAssetID(
    $assetID: ModelIDKeyConditionInput
    $composedForecastID: ID!
    $filter: ModelComposedForecastAssetsFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    composedForecastAssetsByComposedForecastIDAndAssetID(
      assetID: $assetID
      composedForecastID: $composedForecastID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        assetID
        composedForecastID
        createdAt
        icon
        id
        isDefault
        organizationId
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const composedForecastDataSourcesByComposedForecastIdAndPriority = /* GraphQL */ `
  query ComposedForecastDataSourcesByComposedForecastIdAndPriority(
    $composedForecastId: ID!
    $filter: ModelComposedForecastDataSourceFilterInput
    $limit: Int
    $nextToken: String
    $priority: ModelIntKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    composedForecastDataSourcesByComposedForecastIdAndPriority(
      composedForecastId: $composedForecastId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      priority: $priority
      sortDirection: $sortDirection
    ) {
      items {
        composedForecastId
        createdAt
        dataOperations
        dataQualityScore
        externalApiEndpoint
        externalApiHeaders
        externalApiKey
        externalApiParams
        fallbackStrategy
        fallbackValue
        fetchErrorMessage
        groundTruthSensorId
        groundTruthTableName
        id
        isActive
        lastFetchStatus
        lastFetchedAt
        metadata
        modelOutputTimeOffset
        organizationId
        owner
        postgresAggregation
        postgresColumns
        postgresQuery
        postgresTable
        postgresTimeRange
        priority
        processedModelOutputId
        projectId
        s3FileFormat
        s3Location
        s3ParseConfig
        sourceDescription
        sourceName
        sourceType
        temporalResolution
        timeAlignment
        timeLag
        transformations
        updatedAt
        validationRules
        weight
        zarrCoordinates
        zarrPath
        zarrTimeSelection
        zarrVariable
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const composedForecastDataSourcesByProcessedModelOutputId = /* GraphQL */ `
  query ComposedForecastDataSourcesByProcessedModelOutputId(
    $filter: ModelComposedForecastDataSourceFilterInput
    $limit: Int
    $nextToken: String
    $processedModelOutputId: ID!
    $sortDirection: ModelSortDirection
  ) {
    composedForecastDataSourcesByProcessedModelOutputId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelOutputId: $processedModelOutputId
      sortDirection: $sortDirection
    ) {
      items {
        composedForecastId
        createdAt
        dataOperations
        dataQualityScore
        externalApiEndpoint
        externalApiHeaders
        externalApiKey
        externalApiParams
        fallbackStrategy
        fallbackValue
        fetchErrorMessage
        groundTruthSensorId
        groundTruthTableName
        id
        isActive
        lastFetchStatus
        lastFetchedAt
        metadata
        modelOutputTimeOffset
        organizationId
        owner
        postgresAggregation
        postgresColumns
        postgresQuery
        postgresTable
        postgresTimeRange
        priority
        processedModelOutputId
        projectId
        s3FileFormat
        s3Location
        s3ParseConfig
        sourceDescription
        sourceName
        sourceType
        temporalResolution
        timeAlignment
        timeLag
        transformations
        updatedAt
        validationRules
        weight
        zarrCoordinates
        zarrPath
        zarrTimeSelection
        zarrVariable
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dataSetRecordsByDatasetIdAndTimeValue = /* GraphQL */ `
  query DataSetRecordsByDatasetIdAndTimeValue(
    $datasetId: ID!
    $filter: ModelDataSetRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $timeValue: ModelStringKeyConditionInput
  ) {
    dataSetRecordsByDatasetIdAndTimeValue(
      datasetId: $datasetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      timeValue: $timeValue
    ) {
      items {
        columns
        compressedSize
        compressionType
        createdAt
        datasetId
        fileName
        fileSize
        id
        organizationId
        owner
        recordCount
        s3Path
        timeRange
        timeValue
        updatedAt
        uploadId
        uploadedAt
        uploadedBy
        uploadedByEmail
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dataSetRecordsByUploadId = /* GraphQL */ `
  query DataSetRecordsByUploadId(
    $filter: ModelDataSetRecordFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $uploadId: String!
  ) {
    dataSetRecordsByUploadId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      uploadId: $uploadId
    ) {
      items {
        columns
        compressedSize
        compressionType
        createdAt
        datasetId
        fileName
        fileSize
        id
        organizationId
        owner
        recordCount
        s3Path
        timeRange
        timeValue
        updatedAt
        uploadId
        uploadedAt
        uploadedBy
        uploadedByEmail
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const dataSourcesByProcessedModelSchemaId = /* GraphQL */ `
  query DataSourcesByProcessedModelSchemaId(
    $filter: ModelDataSourceFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    dataSourcesByProcessedModelSchemaId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        dataOperations
        databaseTable
        format
        id
        isGroundTruth
        metadata
        name
        organizationId
        owner
        processedModelSchemaId
        s3Path
        sourceType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const datasetFilesByDatasetIdAndPeriodStart = /* GraphQL */ `
  query DatasetFilesByDatasetIdAndPeriodStart(
    $datasetId: ID!
    $filter: ModelDatasetFileFilterInput
    $limit: Int
    $nextToken: String
    $periodStart: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    datasetFilesByDatasetIdAndPeriodStart(
      datasetId: $datasetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      periodStart: $periodStart
      sortDirection: $sortDirection
    ) {
      items {
        active
        columns
        createdAt
        createdByRunId
        datasetId
        granularity
        id
        maxTime
        minTime
        organizationId
        owner
        periodEnd
        periodStart
        retiredAt
        rowCount
        s3Key
        sizeBytes
        supersededBy
        updatedAt
        version
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const datasetProcessingRunsByDatasetIdAndStartedAt = /* GraphQL */ `
  query DatasetProcessingRunsByDatasetIdAndStartedAt(
    $datasetId: ID!
    $filter: ModelDatasetProcessingRunFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $startedAt: ModelStringKeyConditionInput
  ) {
    datasetProcessingRunsByDatasetIdAndStartedAt(
      datasetId: $datasetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      startedAt: $startedAt
    ) {
      items {
        attempts
        createdAt
        datasetId
        error
        finishedAt
        id
        inputFileIds
        inputUploadIds
        logStream
        organizationId
        outputFileIds
        owner
        period
        startedAt
        status
        triggerUploadId
        type
        updatedAt
        warnings
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const datasetUploadsByDatasetIdAndRequestedAt = /* GraphQL */ `
  query DatasetUploadsByDatasetIdAndRequestedAt(
    $datasetId: ID!
    $filter: ModelDatasetUploadFilterInput
    $limit: Int
    $nextToken: String
    $requestedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    datasetUploadsByDatasetIdAndRequestedAt(
      datasetId: $datasetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      requestedAt: $requestedAt
      sortDirection: $sortDirection
    ) {
      items {
        columnMetadata
        columnSources
        columns
        createdAt
        datasetId
        duplicateTimestamps
        failureReason
        fileName
        id
        incomingKey
        inputsReadAt
        organizationId
        outputParamId
        owner
        processedAt
        processedModelSchemaId
        rawKey
        receivedAt
        recordId
        rejectedKey
        requestedAt
        rowCount
        runId
        sizeBytes
        source
        sourceTimezone
        status
        timeRange
        updatedAt
        uploadedBy
        uploadedByEmail
        validationErrors
        warnings
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const datasetsByOrganizationIdAndSlug = /* GraphQL */ `
  query DatasetsByOrganizationIdAndSlug(
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
    $organizationId: ID!
    $slug: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    datasetsByOrganizationIdAndSlug(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      organizationId: $organizationId
      slug: $slug
      sortDirection: $sortDirection
    ) {
      items {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const datasetsByUserIdAndSlug = /* GraphQL */ `
  query DatasetsByUserIdAndSlug(
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
    $slug: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $userId: ID!
  ) {
    datasetsByUserIdAndSlug(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      slug: $slug
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const forecastRecordsByParameterIdAndForecastIssued = /* GraphQL */ `
  query ForecastRecordsByParameterIdAndForecastIssued(
    $filter: ModelForecastRecordFilterInput
    $forecastIssued: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $parameterId: ID!
    $sortDirection: ModelSortDirection
  ) {
    forecastRecordsByParameterIdAndForecastIssued(
      filter: $filter
      forecastIssued: $forecastIssued
      limit: $limit
      nextToken: $nextToken
      parameterId: $parameterId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        forecastIssued
        id
        inputs
        metadata
        organizationId
        owner
        parameterId
        runId
        s3Key
        seriesEnd
        seriesMetaData
        seriesStart
        source
        updatedAt
        uploadId
        uploadedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const forecastRecordsByRunIdAndForecastIssued = /* GraphQL */ `
  query ForecastRecordsByRunIdAndForecastIssued(
    $filter: ModelForecastRecordFilterInput
    $forecastIssued: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $runId: ID!
    $sortDirection: ModelSortDirection
  ) {
    forecastRecordsByRunIdAndForecastIssued(
      filter: $filter
      forecastIssued: $forecastIssued
      limit: $limit
      nextToken: $nextToken
      runId: $runId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        forecastIssued
        id
        inputs
        metadata
        organizationId
        owner
        parameterId
        runId
        s3Key
        seriesEnd
        seriesMetaData
        seriesStart
        source
        updatedAt
        uploadId
        uploadedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const forecastUploadsByOutputParamIdAndRequestedAt = /* GraphQL */ `
  query ForecastUploadsByOutputParamIdAndRequestedAt(
    $filter: ModelForecastUploadFilterInput
    $limit: Int
    $nextToken: String
    $outputParamId: ID!
    $requestedAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    forecastUploadsByOutputParamIdAndRequestedAt(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      outputParamId: $outputParamId
      requestedAt: $requestedAt
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        failureReason
        fileName
        finalKey
        forecastIssued
        forecastRecordId
        id
        incomingKey
        issueTime
        organizationId
        outputParamId
        owner
        parameters
        processedAt
        rawKey
        receivedAt
        requestedAt
        rowCount
        schemaId
        sizeBytes
        source
        status
        timeRange
        updatedAt
        uploadedBy
        uploadedByEmail
        validationErrors
        warnings
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const geoPointsByAssetGroupIdAndName = /* GraphQL */ `
  query GeoPointsByAssetGroupIdAndName(
    $assetGroupId: ID!
    $filter: ModelGeoPointFilterInput
    $limit: Int
    $name: ModelStringKeyConditionInput
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    geoPointsByAssetGroupIdAndName(
      assetGroupId: $assetGroupId
      filter: $filter
      limit: $limit
      name: $name
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const getAccessRequest = /* GraphQL */ `
  query GetAccessRequest($id: ID!) {
    getAccessRequest(id: $id) {
      adminNotes
      createdAt
      description
      email
      id
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const getAgentSchedule = /* GraphQL */ `
  query GetAgentSchedule($id: ID!) {
    getAgentSchedule(id: $id) {
      createdAt
      cronExpression
      description
      error
      id
      lastRunAt
      metadata
      nextRunAt
      organizationId
      owner
      projectId
      runCount
      runners {
        nextToken
        __typename
      }
      runs {
        nextToken
        __typename
      }
      runtime
      status
      systemPrompt
      timezone
      title
      updatedAt
      __typename
    }
  }
`;
export const getAgentScheduleRun = /* GraphQL */ `
  query GetAgentScheduleRun($id: ID!) {
    getAgentScheduleRun(id: $id) {
      conversations {
        nextToken
        __typename
      }
      createdAt
      error
      id
      organizationId
      owner
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      status
      updatedAt
      __typename
    }
  }
`;
export const getAgentScheduleRunner = /* GraphQL */ `
  query GetAgentScheduleRunner($id: ID!) {
    getAgentScheduleRunner(id: $id) {
      attachments
      conversations {
        nextToken
        __typename
      }
      createdAt
      emailCondition
      emailConditionMode
      id
      organizationId
      owner
      prompt
      schedule {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      scheduleId
      sendEmail
      sortOrder
      title
      updatedAt
      __typename
    }
  }
`;
export const getApiIdempotencyKey = /* GraphQL */ `
  query GetApiIdempotencyKey($id: ID!) {
    getApiIdempotencyKey(id: $id) {
      claimToken
      createdAt
      expiresAt
      id
      owner
      requestHash
      response
      responseStatus
      route
      status
      updatedAt
      __typename
    }
  }
`;
export const getAssetGroup = /* GraphQL */ `
  query GetAssetGroup($id: ID!) {
    getAssetGroup(id: $id) {
      assets {
        nextToken
        __typename
      }
      createdAt
      description
      displayedChannels
      id
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      name
      organizationId
      owner
      profilePictureUrl
      updatedAt
      userAssetGroupsId
      __typename
    }
  }
`;
export const getComposedForecast = /* GraphQL */ `
  query GetComposedForecast($id: ID!) {
    getComposedForecast(id: $id) {
      aggregationMethod
      createdAt
      dataSources {
        nextToken
        __typename
      }
      description
      forecastHorizon
      forecastType
      id
      isActive
      lastProcessed
      linkedAssets {
        nextToken
        __typename
      }
      name
      organizationId
      outputParameters
      owner
      processingSchedule
      updateFrequency
      updatedAt
      validationThresholds
      __typename
    }
  }
`;
export const getComposedForecastAssets = /* GraphQL */ `
  query GetComposedForecastAssets($id: ID!) {
    getComposedForecastAssets(id: $id) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastID
      createdAt
      icon
      id
      isDefault
      organizationId
      owner
      updatedAt
      __typename
    }
  }
`;
export const getComposedForecastDataSource = /* GraphQL */ `
  query GetComposedForecastDataSource($id: ID!) {
    getComposedForecastDataSource(id: $id) {
      composedForecast {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      composedForecastId
      createdAt
      dataOperations
      dataQualityScore
      externalApiEndpoint
      externalApiHeaders
      externalApiKey
      externalApiParams
      fallbackStrategy
      fallbackValue
      fetchErrorMessage
      groundTruthSensorId
      groundTruthTableName
      id
      isActive
      lastFetchStatus
      lastFetchedAt
      metadata
      modelOutputTimeOffset
      organizationId
      owner
      postgresAggregation
      postgresColumns
      postgresQuery
      postgresTable
      postgresTimeRange
      priority
      processedModelOutput {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      processedModelOutputId
      projectId
      s3FileFormat
      s3Location
      s3ParseConfig
      sourceDescription
      sourceName
      sourceType
      temporalResolution
      timeAlignment
      timeLag
      transformations
      updatedAt
      validationRules
      weight
      zarrCoordinates
      zarrPath
      zarrTimeSelection
      zarrVariable
      __typename
    }
  }
`;
export const getDataSetRecord = /* GraphQL */ `
  query GetDataSetRecord($id: ID!) {
    getDataSetRecord(id: $id) {
      columns
      compressedSize
      compressionType
      createdAt
      dataset {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      datasetId
      fileName
      fileSize
      id
      organizationId
      owner
      recordCount
      s3Path
      timeRange
      timeValue
      updatedAt
      uploadId
      uploadedAt
      uploadedBy
      uploadedByEmail
      __typename
    }
  }
`;
export const getDataSource = /* GraphQL */ `
  query GetDataSource($id: ID!) {
    getDataSource(id: $id) {
      createdAt
      dataOperations
      databaseTable
      format
      id
      isGroundTruth
      metadata
      name
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      s3Path
      sourceType
      updatedAt
      __typename
    }
  }
`;
export const getDataset = /* GraphQL */ `
  query GetDataset($id: ID!) {
    getDataset(id: $id) {
      columns
      createdAt
      curationMode
      datasetType
      deletedAt
      description
      duplicatePolicy
      fileFormat
      fileSize
      id
      ingestMetadata
      lastUpdated
      linkedAssets
      linkedSchemas
      location
      locationId
      name
      organizationId
      owner
      parameterType
      profilePictureUrl
      recordCount
      records {
        nextToken
        __typename
      }
      routeLong
      slug
      sourceModelId
      tags
      timeRange
      units
      updateFrequency
      updatedAt
      userId
      __typename
    }
  }
`;
export const getDatasetFile = /* GraphQL */ `
  query GetDatasetFile($id: ID!) {
    getDatasetFile(id: $id) {
      active
      columns
      createdAt
      createdByRunId
      datasetId
      granularity
      id
      maxTime
      minTime
      organizationId
      owner
      periodEnd
      periodStart
      retiredAt
      rowCount
      s3Key
      sizeBytes
      supersededBy
      updatedAt
      version
      __typename
    }
  }
`;
export const getDatasetProcessingRun = /* GraphQL */ `
  query GetDatasetProcessingRun($id: ID!) {
    getDatasetProcessingRun(id: $id) {
      attempts
      createdAt
      datasetId
      error
      finishedAt
      id
      inputFileIds
      inputUploadIds
      logStream
      organizationId
      outputFileIds
      owner
      period
      startedAt
      status
      triggerUploadId
      type
      updatedAt
      warnings
      __typename
    }
  }
`;
export const getDatasetUpload = /* GraphQL */ `
  query GetDatasetUpload($id: ID!) {
    getDatasetUpload(id: $id) {
      columnMetadata
      columnSources
      columns
      createdAt
      datasetId
      duplicateTimestamps
      failureReason
      fileName
      id
      incomingKey
      inputsReadAt
      organizationId
      outputParamId
      owner
      processedAt
      processedModelSchemaId
      rawKey
      receivedAt
      recordId
      rejectedKey
      requestedAt
      rowCount
      runId
      sizeBytes
      source
      sourceTimezone
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const getErrorLog = /* GraphQL */ `
  query GetErrorLog($id: ID!) {
    getErrorLog(id: $id) {
      adminNotes
      cognitoIdentityId
      createdAt
      description
      id
      images
      mcpConversationId
      mcpMessageId
      owner
      pageUrl
      source
      status
      updatedAt
      userEmail
      __typename
    }
  }
`;
export const getForecastRecord = /* GraphQL */ `
  query GetForecastRecord($id: ID!) {
    getForecastRecord(id: $id) {
      createdAt
      forecastIssued
      id
      inputs
      metadata
      organizationId
      owner
      parameter {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      parameterId
      run {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      runId
      s3Key
      seriesEnd
      seriesMetaData
      seriesStart
      source
      updatedAt
      uploadId
      uploadedBy
      __typename
    }
  }
`;
export const getForecastReport = /* GraphQL */ `
  query GetForecastReport($id: ID!) {
    getForecastReport(id: $id) {
      completedAt
      config
      createdAt
      description
      error
      id
      identityId
      name
      organizationId
      owner
      progress
      resultS3Key
      startedAt
      status
      summary
      updatedAt
      __typename
    }
  }
`;
export const getForecastUpload = /* GraphQL */ `
  query GetForecastUpload($id: ID!) {
    getForecastUpload(id: $id) {
      createdAt
      failureReason
      fileName
      finalKey
      forecastIssued
      forecastRecordId
      id
      incomingKey
      issueTime
      organizationId
      outputParamId
      owner
      parameters
      processedAt
      rawKey
      receivedAt
      requestedAt
      rowCount
      schemaId
      sizeBytes
      source
      status
      timeRange
      updatedAt
      uploadedBy
      uploadedByEmail
      validationErrors
      warnings
      __typename
    }
  }
`;
export const getGeoPoint = /* GraphQL */ `
  query GetGeoPoint($id: ID!) {
    getGeoPoint(id: $id) {
      assetGroupId
      client
      createdAt
      description
      displayedChannels
      elevation
      geojson
      icon
      id
      imageUrl
      lat
      linkedComposedForecasts {
        nextToken
        __typename
      }
      linkedProcessedModelSchemas {
        nextToken
        __typename
      }
      lng
      name
      organizationId
      owner
      precipCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      precipCurveId
      processedModels {
        nextToken
        __typename
      }
      solarCurve {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      solarCurveId
      tags
      updatedAt
      userGeoPointsId
      value {
        currency
        value
        __typename
      }
      windCurve {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      windCurveId
      __typename
    }
  }
`;
export const getLlmResponse = /* GraphQL */ `
  query GetLlmResponse($id: ID!) {
    getLlmResponse(id: $id) {
      conversation
      createdAt
      description
      executionTime
      id
      owner
      queryType
      response
      updatedAt
      uploadURL
      __typename
    }
  }
`;
export const getLoginAccessCodes = /* GraphQL */ `
  query GetLoginAccessCodes($code: String!) {
    getLoginAccessCodes(code: $code) {
      activatedBy
      available
      code
      createdAt
      notes
      recipient
      updatedAt
      __typename
    }
  }
`;
export const getMCPConversation = /* GraphQL */ `
  query GetMCPConversation($id: ID!) {
    getMCPConversation(id: $id) {
      agentScheduleRunId
      agentScheduleRunnerId
      conversationType
      createdAt
      id
      isActive
      lastMessageAt
      messageCount
      messages {
        nextToken
        __typename
      }
      metadata
      model
      modelCodename
      organizationId
      owner
      projectId
      projectTaskId
      title
      totalTokens
      unreadCount
      updatedAt
      __typename
    }
  }
`;
export const getMCPMessage = /* GraphQL */ `
  query GetMCPMessage($id: ID!) {
    getMCPMessage(id: $id) {
      attachments
      content
      conversation {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      conversationId
      createdAt
      enhancedPrompt
      executionTimeMs
      id
      inputTokens
      isUser
      messageRead
      model
      modelCodename
      organizationId
      outputTokens
      owner
      rating
      ratingComment
      rounds
      serverId
      sessionId
      status
      toolsCount
      updatedAt
      __typename
    }
  }
`;
export const getMCPSharedConversation = /* GraphQL */ `
  query GetMCPSharedConversation($id: ID!) {
    getMCPSharedConversation(id: $id) {
      conversationId
      conversationType
      createdAt
      id
      includePrompts
      isActive
      messageId
      organizationId
      owner
      s3Key
      scheduleRunnerId
      scope
      title
      updatedAt
      __typename
    }
  }
`;
export const getMCPUsage = /* GraphQL */ `
  query GetMCPUsage($id: ID!) {
    getMCPUsage(id: $id) {
      createdAt
      id
      period
      requestCount
      subscriptionTier
      tokenLimit
      tokensUsed
      updatedAt
      userId
      __typename
    }
  }
`;
export const getModelSchemaTemplate = /* GraphQL */ `
  query GetModelSchemaTemplate($id: ID!) {
    getModelSchemaTemplate(id: $id) {
      authorProfileId
      authorType
      category
      createdAt
      createdBy
      description
      executionUrl
      external
      fieldDefinitions
      historicalConfig
      id
      isActive
      modelKind
      name
      profilePictureUrl
      requiresTraining
      tags
      trainingCost
      updatedAt
      version
      __typename
    }
  }
`;
export const getOrganization = /* GraphQL */ `
  query GetOrganization($id: ID!) {
    getOrganization(id: $id) {
      createdAt
      description
      id
      members {
        nextToken
        __typename
      }
      name
      orgAiAnalystAccess
      owner
      profilePictureUrl
      updatedAt
      __typename
    }
  }
`;
export const getOrganizationPublicProfile = /* GraphQL */ `
  query GetOrganizationPublicProfile($id: ID!) {
    getOrganizationPublicProfile(id: $id) {
      bio
      createdAt
      displayName
      email
      employees {
        nextToken
        __typename
      }
      id
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const getPerformanceCurve = /* GraphQL */ `
  query GetPerformanceCurve($id: ID!) {
    getPerformanceCurve(id: $id) {
      createdAt
      curveData {
        x
        y
        __typename
      }
      description
      id
      name
      organizationId
      organizationIds
      owner
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const getProcessedModel = /* GraphQL */ `
  query GetProcessedModel($id: ID!) {
    getProcessedModel(id: $id) {
      additionalDataPoints {
        color
        id
        lookbackDays
        name
        parameterId
        schema
        source
        __typename
      }
      assetId
      createdAt
      deliveryCron
      deliveryGraceMinutes
      deliveryMatchBy
      deliveryTimezone
      deliveryTrackingStartedAt
      description
      displayType
      geopoint {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      id
      label
      modelType
      organizationId
      owner
      routeLong
      routeShort
      schema
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelOutputParam = /* GraphQL */ `
  query GetProcessedModelOutputParam($id: ID!) {
    getProcessedModelOutputParam(id: $id) {
      active
      channels
      createdAt
      description
      forecasts {
        nextToken
        __typename
      }
      id
      name
      organizationId
      outputLocation
      owner
      parameterTypeId
      schema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      schemaId
      seriesMetaData
      storageMode
      targetDatasetId
      unit
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelRunHistory = /* GraphQL */ `
  query GetProcessedModelRunHistory($id: ID!) {
    getProcessedModelRunHistory(id: $id) {
      acknowledged
      acknowledgedAt
      acknowledgedBy
      attempt
      completedAt
      createdAt
      description
      executionTimeMs
      forecasts {
        nextToken
        __typename
      }
      id
      inputs
      modelSchemaTemplateId
      organizationId
      outputS3Keys
      owner
      processedModelScheduleId
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaId
      requestId
      startedAt
      status
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const getProcessedModelRunRequest = /* GraphQL */ `
  query GetProcessedModelRunRequest($id: ID!) {
    getProcessedModelRunRequest(id: $id) {
      attempts
      backfillId
      chunkCount
      chunkIndex
      completedAt
      createdAt
      error
      id
      mergedInto
      notBefore
      organizationId
      owner
      processedModelSchemaId
      runIds
      startedAt
      status
      triggerRef
      triggerType
      updatedAt
      windowEnd
      windowStart
      __typename
    }
  }
`;
export const getProcessedModelRunState = /* GraphQL */ `
  query GetProcessedModelRunState($id: ID!) {
    getProcessedModelRunState(id: $id) {
      createdAt
      id
      lastRequestId
      lastSucceededAt
      leaseHolder
      leaseRequestId
      leaseRunId
      leaseUntil
      organizationId
      owner
      processedThrough
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelSchedule = /* GraphQL */ `
  query GetProcessedModelSchedule($id: ID!) {
    getProcessedModelSchedule(id: $id) {
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      lastRunAt
      nextRunAt
      organizationId
      owner
      processedModelSchemaId
      runCount
      status
      timezone
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelSchema = /* GraphQL */ `
  query GetProcessedModelSchema($id: ID!) {
    getProcessedModelSchema(id: $id) {
      activeStatus
      createdAt
      dataSources {
        nextToken
        __typename
      }
      deliveryExpectation
      dependency
      description
      executionUrl
      historicalSettings
      id
      isActive
      linkedAssetGroups {
        nextToken
        __typename
      }
      linkedAssets {
        nextToken
        __typename
      }
      linkedDatasets {
        nextToken
        __typename
      }
      linkedOutputs {
        nextToken
        __typename
      }
      modelKind
      name
      organizationId
      outputs {
        nextToken
        __typename
      }
      owner
      runHistory {
        nextToken
        __typename
      }
      runSchedule
      s3BasePath
      schemaFields
      schemaType
      type
      updatedAt
      version
      __typename
    }
  }
`;
export const getProcessedModelSchemaAssetGroups = /* GraphQL */ `
  query GetProcessedModelSchemaAssetGroups($id: ID!) {
    getProcessedModelSchemaAssetGroups(id: $id) {
      assetGroup {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      assetGroupID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelSchemaAssets = /* GraphQL */ `
  query GetProcessedModelSchemaAssets($id: ID!) {
    getProcessedModelSchemaAssets(id: $id) {
      asset {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      assetID
      createdAt
      id
      organizationId
      owner
      processedModelSchema {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      processedModelSchemaID
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelSchemaDatasets = /* GraphQL */ `
  query GetProcessedModelSchemaDatasets($id: ID!) {
    getProcessedModelSchemaDatasets(id: $id) {
      backfills
      columns
      createdAt
      crossOrg
      datasetId
      fieldKey
      id
      organizationId
      owner
      processedModelSchemaId
      status
      statusReason
      triggerOnUpload
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelSchemaOutputs = /* GraphQL */ `
  query GetProcessedModelSchemaOutputs($id: ID!) {
    getProcessedModelSchemaOutputs(id: $id) {
      backfills
      columns
      createdAt
      crossOrg
      fieldKey
      id
      organizationId
      outputParamId
      owner
      processedModelSchemaId
      sourceModelId
      sourceStorageMode
      status
      statusReason
      triggerOnUpdate
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelV1EmailLog = /* GraphQL */ `
  query GetProcessedModelV1EmailLog($id: ID!) {
    getProcessedModelV1EmailLog(id: $id) {
      assetCount
      assetNames
      ccRecipientCount
      chartsRendered
      completedAt
      createdAt
      errorMessage
      id
      recipientCount
      scheduleId
      startedAt
      status
      updatedAt
      __typename
    }
  }
`;
export const getProcessedModelV1EmailSchedule = /* GraphQL */ `
  query GetProcessedModelV1EmailSchedule($id: ID!) {
    getProcessedModelV1EmailSchedule(id: $id) {
      ccRecipients
      createdAt
      cronExpression
      firstRunTime
      frequency
      id
      label
      lastRunAt
      nextRunAt
      organizationId
      owner
      recipients
      runCount
      status
      targets {
        assetId
        assetName
        __typename
      }
      timezone
      updatedAt
      __typename
    }
  }
`;
export const getPublicProfile = /* GraphQL */ `
  query GetPublicProfile($id: ID!) {
    getPublicProfile(id: $id) {
      bio
      createdAt
      displayName
      email
      id
      organizationProfileId
      owner
      profilePictureUrl
      showBio
      showDisplayName
      showEmail
      showProfilePicture
      updatedAt
      __typename
    }
  }
`;
export const getSolarEnergyModel = /* GraphQL */ `
  query GetSolarEnergyModel($id: ID!) {
    getSolarEnergyModel(id: $id) {
      acCap
      arrayAzimuth
      arrayTilt
      createdAt
      dcCap
      description
      groundCoverRatio
      id
      maxTilt
      minIrradiance
      name
      owner
      panelEfficiency
      thermalLoss
      trackingType
      updatedAt
      xUnit
      yUnit
      __typename
    }
  }
`;
export const getSystemPrompt = /* GraphQL */ `
  query GetSystemPrompt($id: ID!) {
    getSystemPrompt(id: $id) {
      createdAt
      description
      id
      isDefault
      model
      promptText
      rating
      surface
      updatedAt
      __typename
    }
  }
`;
export const getUploadData = /* GraphQL */ `
  query GetUploadData($id: ID!) {
    getUploadData(id: $id) {
      createdAt
      description
      fileLocation
      id
      name
      objective
      optimizationHorizon
      owner
      parameter
      seasonality
      temporalResolution
      updatedAt
      __typename
    }
  }
`;
export const getUser = /* GraphQL */ `
  query GetUser($id: ID!) {
    getUser(id: $id) {
      assetCount
      assetGroupCount
      assetGroups {
        nextToken
        __typename
      }
      chatPrivacyPolicyAccepted
      chatPrivacyPolicyLocation
      cognitoIdentityId
      createdAt
      email
      geoPoints {
        nextToken
        __typename
      }
      id
      name
      organizationIds
      organizations {
        nextToken
        __typename
      }
      personas {
        nextToken
        __typename
      }
      preferredPersona {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      preferredPersonaId
      privacyPolicyAuditTrail
      profilePictureUrl
      termsAndConditionsAuditTrail
      termsAndConditionsLocation
      termsAndConditionsReviewed
      tourAssetSeen
      tourChatCompleted
      tourGroupSeen
      tourOnboardingGuidanceSent
      tourWelcomeShown
      updatedAt
      userConsent
      username
      __typename
    }
  }
`;
export const getUserChecklistProgress = /* GraphQL */ `
  query GetUserChecklistProgress($id: ID!) {
    getUserChecklistProgress(id: $id) {
      createdAt
      hatUnlocked
      id
      loginDates
      owner
      shippingAddress
      step1Complete
      step2Complete
      step3Complete
      step4Complete
      step5Complete
      step6Complete
      updatedAt
      userId
      welcomeShown
      __typename
    }
  }
`;
export const getUserOrganizations = /* GraphQL */ `
  query GetUserOrganizations($id: ID!) {
    getUserOrganizations(id: $id) {
      createdAt
      id
      organization {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      organizationId
      owner
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userID
      __typename
    }
  }
`;
export const getUserPersona = /* GraphQL */ `
  query GetUserPersona($id: ID!) {
    getUserPersona(id: $id) {
      completed
      createdAt
      description
      id
      markets
      name
      owner
      regions
      selectedNeeds
      summary
      updatedAt
      user {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      userId
      __typename
    }
  }
`;
export const getUserProject = /* GraphQL */ `
  query GetUserProject($id: ID!) {
    getUserProject(id: $id) {
      createdAt
      datasetIds
      description
      id
      imageUrl
      organizationId
      owner
      tasks {
        nextToken
        __typename
      }
      title
      updatedAt
      __typename
    }
  }
`;
export const getUserProjectTask = /* GraphQL */ `
  query GetUserProjectTask($id: ID!) {
    getUserProjectTask(id: $id) {
      completedTask
      createdAt
      description
      id
      order
      owner
      project {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      projectId
      title
      updatedAt
      __typename
    }
  }
`;
export const getUserSubscription = /* GraphQL */ `
  query GetUserSubscription($id: ID!) {
    getUserSubscription(id: $id) {
      cancelAt
      cancelAtPeriodEnd
      createdAt
      currentPeriodEnd
      customerId
      entitlements
      id
      items
      lastPaymentDate
      lastPaymentStatus
      livemode
      owner
      status
      updatedAt
      __typename
    }
  }
`;
export const getUserTokenGrant = /* GraphQL */ `
  query GetUserTokenGrant($id: ID!) {
    getUserTokenGrant(id: $id) {
      active
      createdAt
      email
      expiresAt
      grantedBy
      id
      notes
      tokenLimit
      updatedAt
      __typename
    }
  }
`;
export const listAccessRequests = /* GraphQL */ `
  query ListAccessRequests(
    $filter: ModelAccessRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAccessRequests(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        adminNotes
        createdAt
        description
        email
        id
        owner
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentScheduleRunners = /* GraphQL */ `
  query ListAgentScheduleRunners(
    $filter: ModelAgentScheduleRunnerFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentScheduleRunners(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attachments
        createdAt
        emailCondition
        emailConditionMode
        id
        organizationId
        owner
        prompt
        scheduleId
        sendEmail
        sortOrder
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentScheduleRuns = /* GraphQL */ `
  query ListAgentScheduleRuns(
    $filter: ModelAgentScheduleRunFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentScheduleRuns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        error
        id
        organizationId
        owner
        scheduleId
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAgentSchedules = /* GraphQL */ `
  query ListAgentSchedules(
    $filter: ModelAgentScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAgentSchedules(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        cronExpression
        description
        error
        id
        lastRunAt
        metadata
        nextRunAt
        organizationId
        owner
        projectId
        runCount
        runtime
        status
        systemPrompt
        timezone
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listApiIdempotencyKeys = /* GraphQL */ `
  query ListApiIdempotencyKeys(
    $filter: ModelApiIdempotencyKeyFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listApiIdempotencyKeys(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        claimToken
        createdAt
        expiresAt
        id
        owner
        requestHash
        response
        responseStatus
        route
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listAssetGroups = /* GraphQL */ `
  query ListAssetGroups(
    $filter: ModelAssetGroupFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listAssetGroups(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        displayedChannels
        id
        name
        organizationId
        owner
        profilePictureUrl
        updatedAt
        userAssetGroupsId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComposedForecastAssets = /* GraphQL */ `
  query ListComposedForecastAssets(
    $filter: ModelComposedForecastAssetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComposedForecastAssets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        assetID
        composedForecastID
        createdAt
        icon
        id
        isDefault
        organizationId
        owner
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComposedForecastDataSources = /* GraphQL */ `
  query ListComposedForecastDataSources(
    $filter: ModelComposedForecastDataSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComposedForecastDataSources(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        composedForecastId
        createdAt
        dataOperations
        dataQualityScore
        externalApiEndpoint
        externalApiHeaders
        externalApiKey
        externalApiParams
        fallbackStrategy
        fallbackValue
        fetchErrorMessage
        groundTruthSensorId
        groundTruthTableName
        id
        isActive
        lastFetchStatus
        lastFetchedAt
        metadata
        modelOutputTimeOffset
        organizationId
        owner
        postgresAggregation
        postgresColumns
        postgresQuery
        postgresTable
        postgresTimeRange
        priority
        processedModelOutputId
        projectId
        s3FileFormat
        s3Location
        s3ParseConfig
        sourceDescription
        sourceName
        sourceType
        temporalResolution
        timeAlignment
        timeLag
        transformations
        updatedAt
        validationRules
        weight
        zarrCoordinates
        zarrPath
        zarrTimeSelection
        zarrVariable
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listComposedForecasts = /* GraphQL */ `
  query ListComposedForecasts(
    $filter: ModelComposedForecastFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listComposedForecasts(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        aggregationMethod
        createdAt
        description
        forecastHorizon
        forecastType
        id
        isActive
        lastProcessed
        name
        organizationId
        outputParameters
        owner
        processingSchedule
        updateFrequency
        updatedAt
        validationThresholds
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDataSetRecords = /* GraphQL */ `
  query ListDataSetRecords(
    $filter: ModelDataSetRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataSetRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        columns
        compressedSize
        compressionType
        createdAt
        datasetId
        fileName
        fileSize
        id
        organizationId
        owner
        recordCount
        s3Path
        timeRange
        timeValue
        updatedAt
        uploadId
        uploadedAt
        uploadedBy
        uploadedByEmail
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDataSources = /* GraphQL */ `
  query ListDataSources(
    $filter: ModelDataSourceFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDataSources(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        dataOperations
        databaseTable
        format
        id
        isGroundTruth
        metadata
        name
        organizationId
        owner
        processedModelSchemaId
        s3Path
        sourceType
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDatasetFiles = /* GraphQL */ `
  query ListDatasetFiles(
    $filter: ModelDatasetFileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetFiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        active
        columns
        createdAt
        createdByRunId
        datasetId
        granularity
        id
        maxTime
        minTime
        organizationId
        owner
        periodEnd
        periodStart
        retiredAt
        rowCount
        s3Key
        sizeBytes
        supersededBy
        updatedAt
        version
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDatasetProcessingRuns = /* GraphQL */ `
  query ListDatasetProcessingRuns(
    $filter: ModelDatasetProcessingRunFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetProcessingRuns(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attempts
        createdAt
        datasetId
        error
        finishedAt
        id
        inputFileIds
        inputUploadIds
        logStream
        organizationId
        outputFileIds
        owner
        period
        startedAt
        status
        triggerUploadId
        type
        updatedAt
        warnings
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDatasetUploads = /* GraphQL */ `
  query ListDatasetUploads(
    $filter: ModelDatasetUploadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasetUploads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        columnMetadata
        columnSources
        columns
        createdAt
        datasetId
        duplicateTimestamps
        failureReason
        fileName
        id
        incomingKey
        inputsReadAt
        organizationId
        outputParamId
        owner
        processedAt
        processedModelSchemaId
        rawKey
        receivedAt
        recordId
        rejectedKey
        requestedAt
        rowCount
        runId
        sizeBytes
        source
        sourceTimezone
        status
        timeRange
        updatedAt
        uploadedBy
        uploadedByEmail
        validationErrors
        warnings
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listDatasets = /* GraphQL */ `
  query ListDatasets(
    $filter: ModelDatasetFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listDatasets(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        columns
        createdAt
        curationMode
        datasetType
        deletedAt
        description
        duplicatePolicy
        fileFormat
        fileSize
        id
        ingestMetadata
        lastUpdated
        linkedAssets
        linkedSchemas
        location
        locationId
        name
        organizationId
        owner
        parameterType
        profilePictureUrl
        recordCount
        routeLong
        slug
        sourceModelId
        tags
        timeRange
        units
        updateFrequency
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listErrorLogs = /* GraphQL */ `
  query ListErrorLogs(
    $filter: ModelErrorLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listErrorLogs(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        adminNotes
        cognitoIdentityId
        createdAt
        description
        id
        images
        mcpConversationId
        mcpMessageId
        owner
        pageUrl
        source
        status
        updatedAt
        userEmail
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listForecastRecords = /* GraphQL */ `
  query ListForecastRecords(
    $filter: ModelForecastRecordFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForecastRecords(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        forecastIssued
        id
        inputs
        metadata
        organizationId
        owner
        parameterId
        runId
        s3Key
        seriesEnd
        seriesMetaData
        seriesStart
        source
        updatedAt
        uploadId
        uploadedBy
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listForecastReports = /* GraphQL */ `
  query ListForecastReports(
    $filter: ModelForecastReportFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForecastReports(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        completedAt
        config
        createdAt
        description
        error
        id
        identityId
        name
        organizationId
        owner
        progress
        resultS3Key
        startedAt
        status
        summary
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listForecastUploads = /* GraphQL */ `
  query ListForecastUploads(
    $filter: ModelForecastUploadFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listForecastUploads(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        failureReason
        fileName
        finalKey
        forecastIssued
        forecastRecordId
        id
        incomingKey
        issueTime
        organizationId
        outputParamId
        owner
        parameters
        processedAt
        rawKey
        receivedAt
        requestedAt
        rowCount
        schemaId
        sizeBytes
        source
        status
        timeRange
        updatedAt
        uploadedBy
        uploadedByEmail
        validationErrors
        warnings
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listGeoPoints = /* GraphQL */ `
  query ListGeoPoints(
    $filter: ModelGeoPointFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listGeoPoints(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        assetGroupId
        client
        createdAt
        description
        displayedChannels
        elevation
        geojson
        icon
        id
        imageUrl
        lat
        lng
        name
        organizationId
        owner
        precipCurveId
        solarCurveId
        tags
        updatedAt
        userGeoPointsId
        windCurveId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLlmResponses = /* GraphQL */ `
  query ListLlmResponses(
    $filter: ModelLlmResponseFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listLlmResponses(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        conversation
        createdAt
        description
        executionTime
        id
        owner
        queryType
        response
        updatedAt
        uploadURL
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listLoginAccessCodes = /* GraphQL */ `
  query ListLoginAccessCodes(
    $code: String
    $filter: ModelLoginAccessCodesFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listLoginAccessCodes(
      code: $code
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activatedBy
        available
        code
        createdAt
        notes
        recipient
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMCPConversations = /* GraphQL */ `
  query ListMCPConversations(
    $filter: ModelMCPConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMCPConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMCPMessages = /* GraphQL */ `
  query ListMCPMessages(
    $filter: ModelMCPMessageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMCPMessages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        attachments
        content
        conversationId
        createdAt
        enhancedPrompt
        executionTimeMs
        id
        inputTokens
        isUser
        messageRead
        model
        modelCodename
        organizationId
        outputTokens
        owner
        rating
        ratingComment
        rounds
        serverId
        sessionId
        status
        toolsCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMCPSharedConversations = /* GraphQL */ `
  query ListMCPSharedConversations(
    $filter: ModelMCPSharedConversationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMCPSharedConversations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        conversationId
        conversationType
        createdAt
        id
        includePrompts
        isActive
        messageId
        organizationId
        owner
        s3Key
        scheduleRunnerId
        scope
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listMCPUsages = /* GraphQL */ `
  query ListMCPUsages(
    $filter: ModelMCPUsageFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listMCPUsages(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        id
        period
        requestCount
        subscriptionTier
        tokenLimit
        tokensUsed
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listModelSchemaTemplates = /* GraphQL */ `
  query ListModelSchemaTemplates(
    $filter: ModelModelSchemaTemplateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listModelSchemaTemplates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        authorProfileId
        authorType
        category
        createdAt
        createdBy
        description
        executionUrl
        external
        fieldDefinitions
        historicalConfig
        id
        isActive
        modelKind
        name
        profilePictureUrl
        requiresTraining
        tags
        trainingCost
        updatedAt
        version
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrganizationPublicProfiles = /* GraphQL */ `
  query ListOrganizationPublicProfiles(
    $filter: ModelOrganizationPublicProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizationPublicProfiles(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        bio
        createdAt
        displayName
        email
        id
        owner
        profilePictureUrl
        showBio
        showDisplayName
        showEmail
        showProfilePicture
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listOrganizations = /* GraphQL */ `
  query ListOrganizations(
    $filter: ModelOrganizationFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listOrganizations(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        id
        name
        orgAiAnalystAccess
        owner
        profilePictureUrl
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPerformanceCurves = /* GraphQL */ `
  query ListPerformanceCurves(
    $filter: ModelPerformanceCurveFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPerformanceCurves(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        description
        id
        name
        organizationId
        organizationIds
        owner
        updatedAt
        xUnit
        yUnit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelOutputParams = /* GraphQL */ `
  query ListProcessedModelOutputParams(
    $filter: ModelProcessedModelOutputParamFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelOutputParams(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelRunHistories = /* GraphQL */ `
  query ListProcessedModelRunHistories(
    $filter: ModelProcessedModelRunHistoryFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelRunHistories(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelRunRequests = /* GraphQL */ `
  query ListProcessedModelRunRequests(
    $filter: ModelProcessedModelRunRequestFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelRunRequests(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        attempts
        backfillId
        chunkCount
        chunkIndex
        completedAt
        createdAt
        error
        id
        mergedInto
        notBefore
        organizationId
        owner
        processedModelSchemaId
        runIds
        startedAt
        status
        triggerRef
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelRunStates = /* GraphQL */ `
  query ListProcessedModelRunStates(
    $filter: ModelProcessedModelRunStateFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelRunStates(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        id
        lastRequestId
        lastSucceededAt
        leaseHolder
        leaseRequestId
        leaseRunId
        leaseUntil
        organizationId
        owner
        processedThrough
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchedules = /* GraphQL */ `
  query ListProcessedModelSchedules(
    $filter: ModelProcessedModelScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        cronExpression
        firstRunTime
        frequency
        id
        lastRunAt
        nextRunAt
        organizationId
        owner
        processedModelSchemaId
        runCount
        status
        timezone
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchemaAssetGroups = /* GraphQL */ `
  query ListProcessedModelSchemaAssetGroups(
    $filter: ModelProcessedModelSchemaAssetGroupsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemaAssetGroups(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        assetGroupID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchemaAssets = /* GraphQL */ `
  query ListProcessedModelSchemaAssets(
    $filter: ModelProcessedModelSchemaAssetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemaAssets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        assetID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchemaDatasets = /* GraphQL */ `
  query ListProcessedModelSchemaDatasets(
    $filter: ModelProcessedModelSchemaDatasetsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemaDatasets(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        datasetId
        fieldKey
        id
        organizationId
        owner
        processedModelSchemaId
        status
        statusReason
        triggerOnUpload
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchemaOutputs = /* GraphQL */ `
  query ListProcessedModelSchemaOutputs(
    $filter: ModelProcessedModelSchemaOutputsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemaOutputs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        fieldKey
        id
        organizationId
        outputParamId
        owner
        processedModelSchemaId
        sourceModelId
        sourceStorageMode
        status
        statusReason
        triggerOnUpdate
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelSchemas = /* GraphQL */ `
  query ListProcessedModelSchemas(
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelSchemas(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelV1EmailLogs = /* GraphQL */ `
  query ListProcessedModelV1EmailLogs(
    $filter: ModelProcessedModelV1EmailLogFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelV1EmailLogs(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        assetCount
        assetNames
        ccRecipientCount
        chartsRendered
        completedAt
        createdAt
        errorMessage
        id
        recipientCount
        scheduleId
        startedAt
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModelV1EmailSchedules = /* GraphQL */ `
  query ListProcessedModelV1EmailSchedules(
    $filter: ModelProcessedModelV1EmailScheduleFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModelV1EmailSchedules(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        ccRecipients
        createdAt
        cronExpression
        firstRunTime
        frequency
        id
        label
        lastRunAt
        nextRunAt
        organizationId
        owner
        recipients
        runCount
        status
        timezone
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listProcessedModels = /* GraphQL */ `
  query ListProcessedModels(
    $filter: ModelProcessedModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listProcessedModels(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        assetId
        createdAt
        deliveryCron
        deliveryGraceMinutes
        deliveryMatchBy
        deliveryTimezone
        deliveryTrackingStartedAt
        description
        displayType
        id
        label
        modelType
        organizationId
        owner
        routeLong
        routeShort
        schema
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listPublicProfiles = /* GraphQL */ `
  query ListPublicProfiles(
    $filter: ModelPublicProfileFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPublicProfiles(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        bio
        createdAt
        displayName
        email
        id
        organizationProfileId
        owner
        profilePictureUrl
        showBio
        showDisplayName
        showEmail
        showProfilePicture
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSolarEnergyModels = /* GraphQL */ `
  query ListSolarEnergyModels(
    $filter: ModelSolarEnergyModelFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSolarEnergyModels(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        acCap
        arrayAzimuth
        arrayTilt
        createdAt
        dcCap
        description
        groundCoverRatio
        id
        maxTilt
        minIrradiance
        name
        owner
        panelEfficiency
        thermalLoss
        trackingType
        updatedAt
        xUnit
        yUnit
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listSystemPrompts = /* GraphQL */ `
  query ListSystemPrompts(
    $filter: ModelSystemPromptFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listSystemPrompts(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        id
        isDefault
        model
        promptText
        rating
        surface
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUploadData = /* GraphQL */ `
  query ListUploadData(
    $filter: ModelUploadDataFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUploadData(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        description
        fileLocation
        id
        name
        objective
        optimizationHorizon
        owner
        parameter
        seasonality
        temporalResolution
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserChecklistProgresses = /* GraphQL */ `
  query ListUserChecklistProgresses(
    $filter: ModelUserChecklistProgressFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserChecklistProgresses(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        hatUnlocked
        id
        loginDates
        owner
        shippingAddress
        step1Complete
        step2Complete
        step3Complete
        step4Complete
        step5Complete
        step6Complete
        updatedAt
        userId
        welcomeShown
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserOrganizations = /* GraphQL */ `
  query ListUserOrganizations(
    $filter: ModelUserOrganizationsFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserOrganizations(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        createdAt
        id
        organizationId
        owner
        updatedAt
        userID
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserPersonas = /* GraphQL */ `
  query ListUserPersonas(
    $filter: ModelUserPersonaFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserPersonas(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserProjectTasks = /* GraphQL */ `
  query ListUserProjectTasks(
    $filter: ModelUserProjectTaskFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProjectTasks(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        completedTask
        createdAt
        description
        id
        order
        owner
        projectId
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserProjects = /* GraphQL */ `
  query ListUserProjects(
    $filter: ModelUserProjectFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserProjects(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        createdAt
        datasetIds
        description
        id
        imageUrl
        organizationId
        owner
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserSubscriptions = /* GraphQL */ `
  query ListUserSubscriptions(
    $filter: ModelUserSubscriptionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserSubscriptions(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        cancelAt
        cancelAtPeriodEnd
        createdAt
        currentPeriodEnd
        customerId
        entitlements
        id
        items
        lastPaymentDate
        lastPaymentStatus
        livemode
        owner
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUserTokenGrants = /* GraphQL */ `
  query ListUserTokenGrants(
    $filter: ModelUserTokenGrantFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUserTokenGrants(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        active
        createdAt
        email
        expiresAt
        grantedBy
        id
        notes
        tokenLimit
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const listUsers = /* GraphQL */ `
  query ListUsers(
    $filter: ModelUserFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listUsers(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        assetCount
        assetGroupCount
        chatPrivacyPolicyAccepted
        chatPrivacyPolicyLocation
        cognitoIdentityId
        createdAt
        email
        id
        name
        organizationIds
        preferredPersonaId
        privacyPolicyAuditTrail
        profilePictureUrl
        termsAndConditionsAuditTrail
        termsAndConditionsLocation
        termsAndConditionsReviewed
        tourAssetSeen
        tourChatCompleted
        tourGroupSeen
        tourOnboardingGuidanceSent
        tourWelcomeShown
        updatedAt
        userConsent
        username
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPConversationsByAgentScheduleRunIdAndCreatedAt = /* GraphQL */ `
  query MCPConversationsByAgentScheduleRunIdAndCreatedAt(
    $agentScheduleRunId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPConversationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    mCPConversationsByAgentScheduleRunIdAndCreatedAt(
      agentScheduleRunId: $agentScheduleRunId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPConversationsByAgentScheduleRunnerIdAndCreatedAt = /* GraphQL */ `
  query MCPConversationsByAgentScheduleRunnerIdAndCreatedAt(
    $agentScheduleRunnerId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPConversationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    mCPConversationsByAgentScheduleRunnerIdAndCreatedAt(
      agentScheduleRunnerId: $agentScheduleRunnerId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPConversationsByOwnerAndLastMessageAt = /* GraphQL */ `
  query MCPConversationsByOwnerAndLastMessageAt(
    $filter: ModelMCPConversationFilterInput
    $lastMessageAt: ModelStringKeyConditionInput
    $limit: Int
    $nextToken: String
    $owner: ID!
    $sortDirection: ModelSortDirection
  ) {
    mCPConversationsByOwnerAndLastMessageAt(
      filter: $filter
      lastMessageAt: $lastMessageAt
      limit: $limit
      nextToken: $nextToken
      owner: $owner
      sortDirection: $sortDirection
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPConversationsByProjectIdAndCreatedAt = /* GraphQL */ `
  query MCPConversationsByProjectIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPConversationFilterInput
    $limit: Int
    $nextToken: String
    $projectId: ID!
    $sortDirection: ModelSortDirection
  ) {
    mCPConversationsByProjectIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      projectId: $projectId
      sortDirection: $sortDirection
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPConversationsByProjectTaskIdAndCreatedAt = /* GraphQL */ `
  query MCPConversationsByProjectTaskIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPConversationFilterInput
    $limit: Int
    $nextToken: String
    $projectTaskId: ID!
    $sortDirection: ModelSortDirection
  ) {
    mCPConversationsByProjectTaskIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      projectTaskId: $projectTaskId
      sortDirection: $sortDirection
    ) {
      items {
        agentScheduleRunId
        agentScheduleRunnerId
        conversationType
        createdAt
        id
        isActive
        lastMessageAt
        messageCount
        metadata
        model
        modelCodename
        organizationId
        owner
        projectId
        projectTaskId
        title
        totalTokens
        unreadCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPMessagesByConversationIdAndCreatedAt = /* GraphQL */ `
  query MCPMessagesByConversationIdAndCreatedAt(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPMessageFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    mCPMessagesByConversationIdAndCreatedAt(
      conversationId: $conversationId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        attachments
        content
        conversationId
        createdAt
        enhancedPrompt
        executionTimeMs
        id
        inputTokens
        isUser
        messageRead
        model
        modelCodename
        organizationId
        outputTokens
        owner
        rating
        ratingComment
        rounds
        serverId
        sessionId
        status
        toolsCount
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPSharedConversationsByConversationIdAndCreatedAt = /* GraphQL */ `
  query MCPSharedConversationsByConversationIdAndCreatedAt(
    $conversationId: ID!
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPSharedConversationFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    mCPSharedConversationsByConversationIdAndCreatedAt(
      conversationId: $conversationId
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        conversationId
        conversationType
        createdAt
        id
        includePrompts
        isActive
        messageId
        organizationId
        owner
        s3Key
        scheduleRunnerId
        scope
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPSharedConversationsByScheduleRunnerIdAndCreatedAt = /* GraphQL */ `
  query MCPSharedConversationsByScheduleRunnerIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelMCPSharedConversationFilterInput
    $limit: Int
    $nextToken: String
    $scheduleRunnerId: ID!
    $sortDirection: ModelSortDirection
  ) {
    mCPSharedConversationsByScheduleRunnerIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      scheduleRunnerId: $scheduleRunnerId
      sortDirection: $sortDirection
    ) {
      items {
        conversationId
        conversationType
        createdAt
        id
        includePrompts
        isActive
        messageId
        organizationId
        owner
        s3Key
        scheduleRunnerId
        scope
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const mCPUsagesByUserIdAndPeriod = /* GraphQL */ `
  query MCPUsagesByUserIdAndPeriod(
    $filter: ModelMCPUsageFilterInput
    $limit: Int
    $nextToken: String
    $period: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $userId: String!
  ) {
    mCPUsagesByUserIdAndPeriod(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      period: $period
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        createdAt
        id
        period
        requestCount
        subscriptionTier
        tokenLimit
        tokensUsed
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelOutputParamsByParameterTypeIdAndSchemaId = /* GraphQL */ `
  query ProcessedModelOutputParamsByParameterTypeIdAndSchemaId(
    $filter: ModelProcessedModelOutputParamFilterInput
    $limit: Int
    $nextToken: String
    $parameterTypeId: String!
    $schemaId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    processedModelOutputParamsByParameterTypeIdAndSchemaId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      parameterTypeId: $parameterTypeId
      schemaId: $schemaId
      sortDirection: $sortDirection
    ) {
      items {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelOutputParamsBySchemaIdAndName = /* GraphQL */ `
  query ProcessedModelOutputParamsBySchemaIdAndName(
    $filter: ModelProcessedModelOutputParamFilterInput
    $limit: Int
    $name: ModelStringKeyConditionInput
    $nextToken: String
    $schemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelOutputParamsBySchemaIdAndName(
      filter: $filter
      limit: $limit
      name: $name
      nextToken: $nextToken
      schemaId: $schemaId
      sortDirection: $sortDirection
    ) {
      items {
        active
        channels
        createdAt
        description
        id
        name
        organizationId
        outputLocation
        owner
        parameterTypeId
        schemaId
        seriesMetaData
        storageMode
        targetDatasetId
        unit
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelRunHistoriesByProcessedModelSchemaIdAndCreatedAt = /* GraphQL */ `
  query ProcessedModelRunHistoriesByProcessedModelSchemaIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelProcessedModelRunHistoryFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelRunHistoriesByProcessedModelSchemaIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        acknowledged
        acknowledgedAt
        acknowledgedBy
        attempt
        completedAt
        createdAt
        description
        executionTimeMs
        id
        inputs
        modelSchemaTemplateId
        organizationId
        outputS3Keys
        owner
        processedModelScheduleId
        processedModelSchemaId
        requestId
        startedAt
        status
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelRunRequestsByBackfillIdAndChunkIndex = /* GraphQL */ `
  query ProcessedModelRunRequestsByBackfillIdAndChunkIndex(
    $backfillId: ID!
    $chunkIndex: ModelIntKeyConditionInput
    $filter: ModelProcessedModelRunRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    processedModelRunRequestsByBackfillIdAndChunkIndex(
      backfillId: $backfillId
      chunkIndex: $chunkIndex
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        attempts
        backfillId
        chunkCount
        chunkIndex
        completedAt
        createdAt
        error
        id
        mergedInto
        notBefore
        organizationId
        owner
        processedModelSchemaId
        runIds
        startedAt
        status
        triggerRef
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelRunRequestsByProcessedModelSchemaIdAndCreatedAt = /* GraphQL */ `
  query ProcessedModelRunRequestsByProcessedModelSchemaIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelProcessedModelRunRequestFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelRunRequestsByProcessedModelSchemaIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        attempts
        backfillId
        chunkCount
        chunkIndex
        completedAt
        createdAt
        error
        id
        mergedInto
        notBefore
        organizationId
        owner
        processedModelSchemaId
        runIds
        startedAt
        status
        triggerRef
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelRunRequestsByStatusAndCreatedAt = /* GraphQL */ `
  query ProcessedModelRunRequestsByStatusAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelProcessedModelRunRequestFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $status: ProcessedModelRunRequestStatus!
  ) {
    processedModelRunRequestsByStatusAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      status: $status
    ) {
      items {
        attempts
        backfillId
        chunkCount
        chunkIndex
        completedAt
        createdAt
        error
        id
        mergedInto
        notBefore
        organizationId
        owner
        processedModelSchemaId
        runIds
        startedAt
        status
        triggerRef
        triggerType
        updatedAt
        windowEnd
        windowStart
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchedulesByProcessedModelSchemaIdAndCreatedAt = /* GraphQL */ `
  query ProcessedModelSchedulesByProcessedModelSchemaIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelProcessedModelScheduleFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchedulesByProcessedModelSchemaIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        createdAt
        cronExpression
        firstRunTime
        frequency
        id
        lastRunAt
        nextRunAt
        organizationId
        owner
        processedModelSchemaId
        runCount
        status
        timezone
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchedulesByStatusAndNextRunAt = /* GraphQL */ `
  query ProcessedModelSchedulesByStatusAndNextRunAt(
    $filter: ModelProcessedModelScheduleFilterInput
    $limit: Int
    $nextRunAt: ModelStringKeyConditionInput
    $nextToken: String
    $sortDirection: ModelSortDirection
    $status: ProcessedModelScheduleStatus!
  ) {
    processedModelSchedulesByStatusAndNextRunAt(
      filter: $filter
      limit: $limit
      nextRunAt: $nextRunAt
      nextToken: $nextToken
      sortDirection: $sortDirection
      status: $status
    ) {
      items {
        createdAt
        cronExpression
        firstRunTime
        frequency
        id
        lastRunAt
        nextRunAt
        organizationId
        owner
        processedModelSchemaId
        runCount
        status
        timezone
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaAssetGroupsByAssetGroupIDAndProcessedModelSchemaID = /* GraphQL */ `
  query ProcessedModelSchemaAssetGroupsByAssetGroupIDAndProcessedModelSchemaID(
    $assetGroupID: ID!
    $filter: ModelProcessedModelSchemaAssetGroupsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaAssetGroupsByAssetGroupIDAndProcessedModelSchemaID(
      assetGroupID: $assetGroupID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaID: $processedModelSchemaID
      sortDirection: $sortDirection
    ) {
      items {
        assetGroupID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaAssetGroupsByProcessedModelSchemaIDAndAssetGroupID = /* GraphQL */ `
  query ProcessedModelSchemaAssetGroupsByProcessedModelSchemaIDAndAssetGroupID(
    $assetGroupID: ModelIDKeyConditionInput
    $filter: ModelProcessedModelSchemaAssetGroupsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaID: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaAssetGroupsByProcessedModelSchemaIDAndAssetGroupID(
      assetGroupID: $assetGroupID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaID: $processedModelSchemaID
      sortDirection: $sortDirection
    ) {
      items {
        assetGroupID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaAssetsByAssetIDAndProcessedModelSchemaID = /* GraphQL */ `
  query ProcessedModelSchemaAssetsByAssetIDAndProcessedModelSchemaID(
    $assetID: ID!
    $filter: ModelProcessedModelSchemaAssetsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaID: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaAssetsByAssetIDAndProcessedModelSchemaID(
      assetID: $assetID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaID: $processedModelSchemaID
      sortDirection: $sortDirection
    ) {
      items {
        assetID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaAssetsByProcessedModelSchemaIDAndAssetID = /* GraphQL */ `
  query ProcessedModelSchemaAssetsByProcessedModelSchemaIDAndAssetID(
    $assetID: ModelIDKeyConditionInput
    $filter: ModelProcessedModelSchemaAssetsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaID: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaAssetsByProcessedModelSchemaIDAndAssetID(
      assetID: $assetID
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaID: $processedModelSchemaID
      sortDirection: $sortDirection
    ) {
      items {
        assetID
        createdAt
        id
        organizationId
        owner
        processedModelSchemaID
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaDatasetsByDatasetId = /* GraphQL */ `
  query ProcessedModelSchemaDatasetsByDatasetId(
    $datasetId: ID!
    $filter: ModelProcessedModelSchemaDatasetsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaDatasetsByDatasetId(
      datasetId: $datasetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        datasetId
        fieldKey
        id
        organizationId
        owner
        processedModelSchemaId
        status
        statusReason
        triggerOnUpload
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaDatasetsByProcessedModelSchemaId = /* GraphQL */ `
  query ProcessedModelSchemaDatasetsByProcessedModelSchemaId(
    $filter: ModelProcessedModelSchemaDatasetsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaDatasetsByProcessedModelSchemaId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        datasetId
        fieldKey
        id
        organizationId
        owner
        processedModelSchemaId
        status
        statusReason
        triggerOnUpload
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaOutputsByOutputParamId = /* GraphQL */ `
  query ProcessedModelSchemaOutputsByOutputParamId(
    $filter: ModelProcessedModelSchemaOutputsFilterInput
    $limit: Int
    $nextToken: String
    $outputParamId: ID!
    $processedModelSchemaId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaOutputsByOutputParamId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      outputParamId: $outputParamId
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        fieldKey
        id
        organizationId
        outputParamId
        owner
        processedModelSchemaId
        sourceModelId
        sourceStorageMode
        status
        statusReason
        triggerOnUpdate
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemaOutputsByProcessedModelSchemaId = /* GraphQL */ `
  query ProcessedModelSchemaOutputsByProcessedModelSchemaId(
    $filter: ModelProcessedModelSchemaOutputsFilterInput
    $limit: Int
    $nextToken: String
    $processedModelSchemaId: ID!
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemaOutputsByProcessedModelSchemaId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      processedModelSchemaId: $processedModelSchemaId
      sortDirection: $sortDirection
    ) {
      items {
        backfills
        columns
        createdAt
        crossOrg
        fieldKey
        id
        organizationId
        outputParamId
        owner
        processedModelSchemaId
        sourceModelId
        sourceStorageMode
        status
        statusReason
        triggerOnUpdate
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelSchemasByDependencyAndCreatedAt = /* GraphQL */ `
  query ProcessedModelSchemasByDependencyAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $dependency: String!
    $filter: ModelProcessedModelSchemaFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    processedModelSchemasByDependencyAndCreatedAt(
      createdAt: $createdAt
      dependency: $dependency
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        activeStatus
        createdAt
        deliveryExpectation
        dependency
        description
        executionUrl
        historicalSettings
        id
        isActive
        modelKind
        name
        organizationId
        owner
        runSchedule
        s3BasePath
        schemaFields
        schemaType
        type
        updatedAt
        version
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelV1EmailLogsByScheduleIdAndCreatedAt = /* GraphQL */ `
  query ProcessedModelV1EmailLogsByScheduleIdAndCreatedAt(
    $createdAt: ModelStringKeyConditionInput
    $filter: ModelProcessedModelV1EmailLogFilterInput
    $limit: Int
    $nextToken: String
    $scheduleId: String!
    $sortDirection: ModelSortDirection
  ) {
    processedModelV1EmailLogsByScheduleIdAndCreatedAt(
      createdAt: $createdAt
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      scheduleId: $scheduleId
      sortDirection: $sortDirection
    ) {
      items {
        assetCount
        assetNames
        ccRecipientCount
        chartsRendered
        completedAt
        createdAt
        errorMessage
        id
        recipientCount
        scheduleId
        startedAt
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelV1EmailSchedulesByStatusAndNextRunAt = /* GraphQL */ `
  query ProcessedModelV1EmailSchedulesByStatusAndNextRunAt(
    $filter: ModelProcessedModelV1EmailScheduleFilterInput
    $limit: Int
    $nextRunAt: ModelStringKeyConditionInput
    $nextToken: String
    $sortDirection: ModelSortDirection
    $status: ProcessedModelV1EmailScheduleStatus!
  ) {
    processedModelV1EmailSchedulesByStatusAndNextRunAt(
      filter: $filter
      limit: $limit
      nextRunAt: $nextRunAt
      nextToken: $nextToken
      sortDirection: $sortDirection
      status: $status
    ) {
      items {
        ccRecipients
        createdAt
        cronExpression
        firstRunTime
        frequency
        id
        label
        lastRunAt
        nextRunAt
        organizationId
        owner
        recipients
        runCount
        status
        timezone
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const processedModelsByAssetId = /* GraphQL */ `
  query ProcessedModelsByAssetId(
    $assetId: ID!
    $filter: ModelProcessedModelFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    processedModelsByAssetId(
      assetId: $assetId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        assetId
        createdAt
        deliveryCron
        deliveryGraceMinutes
        deliveryMatchBy
        deliveryTimezone
        deliveryTrackingStartedAt
        description
        displayType
        id
        label
        modelType
        organizationId
        owner
        routeLong
        routeShort
        schema
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const publicProfilesByOrganizationProfileId = /* GraphQL */ `
  query PublicProfilesByOrganizationProfileId(
    $filter: ModelPublicProfileFilterInput
    $limit: Int
    $nextToken: String
    $organizationProfileId: ID!
    $sortDirection: ModelSortDirection
  ) {
    publicProfilesByOrganizationProfileId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      organizationProfileId: $organizationProfileId
      sortDirection: $sortDirection
    ) {
      items {
        bio
        createdAt
        displayName
        email
        id
        organizationProfileId
        owner
        profilePictureUrl
        showBio
        showDisplayName
        showEmail
        showProfilePicture
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const subscriptionsByOwner = /* GraphQL */ `
  query SubscriptionsByOwner(
    $filter: ModelUserSubscriptionFilterInput
    $limit: Int
    $nextToken: String
    $owner: String!
    $sortDirection: ModelSortDirection
  ) {
    subscriptionsByOwner(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      owner: $owner
      sortDirection: $sortDirection
    ) {
      items {
        cancelAt
        cancelAtPeriodEnd
        createdAt
        currentPeriodEnd
        customerId
        entitlements
        id
        items
        lastPaymentDate
        lastPaymentStatus
        livemode
        owner
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userChecklistProgressesByUserId = /* GraphQL */ `
  query UserChecklistProgressesByUserId(
    $filter: ModelUserChecklistProgressFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
    $userId: ID!
  ) {
    userChecklistProgressesByUserId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        createdAt
        hatUnlocked
        id
        loginDates
        owner
        shippingAddress
        step1Complete
        step2Complete
        step3Complete
        step4Complete
        step5Complete
        step6Complete
        updatedAt
        userId
        welcomeShown
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrganizationsByOrganizationIdAndUserID = /* GraphQL */ `
  query UserOrganizationsByOrganizationIdAndUserID(
    $filter: ModelUserOrganizationsFilterInput
    $limit: Int
    $nextToken: String
    $organizationId: ID!
    $sortDirection: ModelSortDirection
    $userID: ModelIDKeyConditionInput
  ) {
    userOrganizationsByOrganizationIdAndUserID(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      organizationId: $organizationId
      sortDirection: $sortDirection
      userID: $userID
    ) {
      items {
        createdAt
        id
        organizationId
        owner
        updatedAt
        userID
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userOrganizationsByUserIDAndOrganizationId = /* GraphQL */ `
  query UserOrganizationsByUserIDAndOrganizationId(
    $filter: ModelUserOrganizationsFilterInput
    $limit: Int
    $nextToken: String
    $organizationId: ModelIDKeyConditionInput
    $sortDirection: ModelSortDirection
    $userID: ID!
  ) {
    userOrganizationsByUserIDAndOrganizationId(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      organizationId: $organizationId
      sortDirection: $sortDirection
      userID: $userID
    ) {
      items {
        createdAt
        id
        organizationId
        owner
        updatedAt
        userID
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userPersonasByUserIdAndName = /* GraphQL */ `
  query UserPersonasByUserIdAndName(
    $filter: ModelUserPersonaFilterInput
    $limit: Int
    $name: ModelStringKeyConditionInput
    $nextToken: String
    $sortDirection: ModelSortDirection
    $userId: ID!
  ) {
    userPersonasByUserIdAndName(
      filter: $filter
      limit: $limit
      name: $name
      nextToken: $nextToken
      sortDirection: $sortDirection
      userId: $userId
    ) {
      items {
        completed
        createdAt
        description
        id
        markets
        name
        owner
        regions
        selectedNeeds
        summary
        updatedAt
        userId
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userProjectTasksByProjectIdAndOrder = /* GraphQL */ `
  query UserProjectTasksByProjectIdAndOrder(
    $filter: ModelUserProjectTaskFilterInput
    $limit: Int
    $nextToken: String
    $order: ModelIntKeyConditionInput
    $projectId: ID!
    $sortDirection: ModelSortDirection
  ) {
    userProjectTasksByProjectIdAndOrder(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      order: $order
      projectId: $projectId
      sortDirection: $sortDirection
    ) {
      items {
        completedTask
        createdAt
        description
        id
        order
        owner
        projectId
        title
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userSubscriptionsByCustomerId = /* GraphQL */ `
  query UserSubscriptionsByCustomerId(
    $customerId: String!
    $filter: ModelUserSubscriptionFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    userSubscriptionsByCustomerId(
      customerId: $customerId
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        cancelAt
        cancelAtPeriodEnd
        createdAt
        currentPeriodEnd
        customerId
        entitlements
        id
        items
        lastPaymentDate
        lastPaymentStatus
        livemode
        owner
        status
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
export const userTokenGrantsByEmail = /* GraphQL */ `
  query UserTokenGrantsByEmail(
    $email: String!
    $filter: ModelUserTokenGrantFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    userTokenGrantsByEmail(
      email: $email
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        active
        createdAt
        email
        expiresAt
        grantedBy
        id
        notes
        tokenLimit
        updatedAt
        __typename
      }
      nextToken
      __typename
    }
  }
`;
